import {makeActionCreator} from '../../redux-toolbelt';

export const setCurrentModal = makeActionCreator('setCurrentModal', (name, args) => (name ? {name, args} : null));
